export default "__VITE_ASSET__Bud9vlGa__"